import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '../common/shared.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class PermissaoCrudGuard implements CanActivate {
  public shared: SharedService;

  constructor(private router: Router) {
    this.shared = SharedService.getInstance();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.shared.isLoggedIn()) {
      let urls: string[] = state.url.split("/");
      let permissao = this.shared.getPermissao(urls[1].concat("/").concat(urls[2]));
      let create = route.routeConfig.path == `${urls[2]}/create`;
      let edit = route.routeConfig.path == `${urls[2]}/:id`;
      let naoLiberado =  !permissao ? true :  create ? !permissao.inserir : edit ? !permissao.alterar : true; 
      if (naoLiberado) {
        this.router.navigate(['/acesso-negado']);
        return false;
      }
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
